module.exports = __webpack_public_path__ + "static/media/whispers.7cad86a1.svg";